module.exports = __webpack_public_path__ + "img/lectores_manuales.448897f2.jpg";